import { MeetingServicePriceListsItem } from "./priceListsTypes"

export const filterPriceList = (
    isFavorite: boolean,
    searchRegex: RegExp | undefined,
    merchants: MeetingServicePriceListsItem[],
): MeetingServicePriceListsItem[] => {
    if (!isFavorite && !searchRegex) return merchants

    return merchants
        .map((merchant) => {
            const filteredPriceLists = merchant.priceLists.filter((priceList) => {
                const passesSearch = searchRegex ? searchRegex.test(priceList.displayName) : true
                const isProductFavorite = isFavorite ? !!priceList.isFavorite : true
                return passesSearch && isProductFavorite
            })

            if (filteredPriceLists.length === merchant.priceLists.length) {
                const isSame = filteredPriceLists.every((pl, idx) => pl === merchant.priceLists[idx])
                if (isSame) return merchant
            }

            return {
                ...merchant,
                priceLists: filteredPriceLists,
            }
        })
        .filter((merchant) => merchant.priceLists.length > 0)
}
